
import ChangeOrderProductDate from '@/components/Modals/ChangeOrderProductDate.vue';

import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        id: {
            type: String,
            required: true
        },
    },
    components: { ChangeOrderProductDate },
    async setup() {
        return {};
    }
});
